var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/utils/slugify.js
var require_slugify = __commonJS({
  "server/utils/slugify.js"(exports, module) {
    var addRandomCharacter = (inputString) => {
      const characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      let randomChars = "";
      for (let i = 0; i < 4; i += 1) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomChars += characters[randomIndex];
      }
      return `${inputString}-${randomChars}`;
    };
    function slugify(str, addRandomCharacters = false) {
      let newString = str;
      newString = newString.replace(/^\s+|\s+$/g, "");
      newString = newString.toLowerCase();
      const from = "\xE0\xE1\xE4\xE2\xE8\xE9\xEB\xEA\xEC\xED\xEF\xEE\xF2\xF3\xF6\xF4\xF9\xFA\xFC\xFB\xF1\xE7\xB7/_,:;";
      const to = "aaaaeeeeiiiioooouuuunc------";
      for (let i = 0, l = from.length; i < l; i += 1) {
        newString = newString.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }
      newString = newString.replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-");
      if (newString.startsWith("-")) {
        newString = newString.slice(1);
      }
      if (newString.endsWith("-")) {
        newString = newString.slice(0, -1);
      }
      if (addRandomCharacters) {
        newString = addRandomCharacter(newString);
      }
      return newString;
    }
    module.exports = {
      slugify
    };
  }
});
const __cjsModule = require_slugify();
export default __cjsModule;
export const slugify = __cjsModule.slugify;
